import LoadingButton from "@material-ui/lab/LoadingButton";
import { CssBaseline, Container, Box, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../res/manageit-logo-blue.svg";
import dtechLogo from "../res/logo.png";
import { useMutation, useQuery } from "react-query";
import { Typography } from "@material-ui/core";
import { approveApp, getApp } from "../api";
import { useSnackbar } from "notistack";
import { getFormPayload } from "../utils";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logo: {
    marginBottom: theme.spacing(1),
  },
  alert: {
    width: "100%",
  },
  form: {
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  line: {
    marginTop: 30,
    width: "100%",
    border: "none",
    borderBottom: "1px solid #c4c4c4",
  },
}));

export default function OAuthAuthorize() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const params = new URLSearchParams(window.location.search);
  const clientID = params.get("client_id");
  const redirectURI = params.get("redirect_uri");

  const { data: appData } = useQuery(["apps", clientID], getApp(clientID), {
    onError: () => {
      window.location.href = "/";
    },
  });

  const {
    mutate: doApprove,
    isLoading,
    error,
  } = useMutation(approveApp, {
    onSuccess: ({ code }) => {
      window.location.href = redirectURI + "?code=" + code;
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });

  const approve = (e) => {
    e.preventDefault();
    doApprove(clientID);
  };

  const onCancel = () => {
    window.location.href = "/";
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img
          alt="manageIT logo"
          width={160}
          src={logo}
          className={classes.logo}
        />
        {appData && (
          <form className={classes.form} onSubmit={approve} noValidate>
            <Box mt={4} mb={4}>
              <Typography variant="body">
                The app <b>{appData.name}</b> wants to access your manageIT
                account. Only approve if you trust the app provider.
              </Typography>
            </Box>
            <LoadingButton
              loading={isLoading}
              loadingPosition="start"
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Approve
            </LoadingButton>
            <Button onClick={onCancel} fullWidth variant="outlined">
              Cancel
            </Button>
          </form>
        )}
        <hr className={classes.line} />
        <img src={dtechLogo} width={80} alt="D-Tech logo" />
        <Typography variant="caption">© D-Tech International Ltd</Typography>
      </div>
    </Container>
  );
}
